import store from '../store';

export function isGuideline() {
    try {
        const storedGuideline = store.state.guideline;
        if (!storedGuideline) {
            return false;
        }
        const jsonStr = JSON.parse(storedGuideline);
        if (!jsonStr || !jsonStr.guideline) {
            return false;
        }
        const guidelineup = process.env.VUE_APP_GUIDELINE_UPDATE;
        return jsonStr.guideline === guidelineup;
    } catch (e) {
        return false;
    }
}